import { IPrismicLink } from '@monofront/types';

export enum HEADER_TYPES {
  DEFAULT = 'default',
  LIGHT_WITH_CTA = 'light with CTA',
  CHECKOUT = 'checkout',
}

export interface IHeader {
  type: HEADER_TYPES;
  headerLightCtaLink: IPrismicLink;
  headerLightCtaText: string;
  headerCheckoutTitle: string;
}

export enum FOOTER_TYPES {
  DEFAULT = 'default',
  LIGHT = 'light',
}
